module.exports = __webpack_public_path__ + "static/media/sensorische-integration.ade73922.jpg";